import React from 'react';
import './Projects.css';

function Projects() {
  return (
    <main className="projects-page">
      <h1>Projects</h1>
      <p className="page-description">
        Selected competition wins and strategic marketing projects that show research, presentation, and campaign execution.
      </p>

      <section className="projects-showcase" aria-labelledby="projects-title">
        <div className="projects-heading">
          <p className="section-kicker">Projects</p>
          <h2 id="projects-title">Competition wins and presentation work.</h2>
        </div>

        <div className="project-grid">
          <article className="award-square">
            <div className="cartoon-trophy" aria-hidden="true">
              <div className="trophy-cup">
                <span className="trophy-handle left"></span>
                <span className="trophy-handle right"></span>
              </div>
              <div className="trophy-stem"></div>
              <div className="trophy-base"></div>
            </div>
            <div>
              <span className="award-label">1st Place</span>
              <h3>Stukent Social Media Marketing Simulation</h3>
              <p>
                Won 1st place out of 90 students for generating the most revenue income in Stukent's Social Media Marketing Simulation.
              </p>
            </div>
          </article>

          <a
            href="https://www.linkedin.com/posts/david-lukin_1-first-place-baby-my-group-and-i-had-share-7439507122431733761-N5uQ/?utm_source=share&utm_medium=member_desktop&rcm=ACoAAFSogH0BVQgZCAurJGn4o9suYgawhRa5xrM"
            target="_blank"
            rel="noopener noreferrer"
            className="featured-project-card"
          >
            <img
              src="/ContentMarketing.jpg"
              alt="Content marketing strategy presentation award group"
              className="project-image"
            />
            <div className="project-copy">
              <span className="award-label">Best Presentation</span>
              <h3>Content Marketing Strategy for Solventum</h3>
              <p>
                Chosen 1st place for best presentation for a content marketing strategy for Solventum by Colle McVoy Ad Agency.
              </p>
            </div>
          </a>

          <a
            href="https://www.linkedin.com/feed/update/urn:li:activity:7445119123287748609/"
            target="_blank"
            rel="noopener noreferrer"
            className="linkedin-project-card"
          >
            <img
              src="/BoschRexrothIME.png"
              alt="Bosch Rexroth and HydraForce IME honors program group"
              className="linkedin-project-image"
            />
            <div className="linkedin-project-copy">
              <span className="award-label">IME Program</span>
              <h3>Bosch Rexroth & HydraForce Collaboration</h3>
              <p>
                I participated in DePaul's IME Honors program collaboration with Bosch Rexroth and HydraForce, working on real-world marketing challenges under their hydraulics collection and helped them understand how they're perceived in the market. 
              </p>
            </div>
          </a>
        </div>
      </section>
    </main>
  );
}

export default Projects;
